import { Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import { BrandRequestMainContent } from '@/layouts/Brand/BrandRequestLayout/BrandRequestLayout';
import { isArchived, isArchivedAndExportedToZendesk, RequestWithRelations } from '@/models/request';
import EstimateDisclaimer from '@/routes/Brand/components/EstimateDisclaimer';
import { ClientArticlesList } from '@/routes/Brand/Requests/Request/components/shared/ClientArticlesList';
import ClientStepper from '@/routes/Brand/Requests/Request/components/shared/ClientStepper';

import { StepMessage } from '../../shared/StepMessage';

const Estimation = ({ request }: { request: RequestWithRelations }) => {
  const showPrice = !!request.articles[0]?.steps?.find((step) => step.step === 'creation')?.config
    ?.requirePrice;
  const hideStepper = isArchivedAndExportedToZendesk(request);

  return (
    <BrandRequestMainContent>
      <Stack gap="1rem">
        {!hideStepper && <ClientStepper request={request} />}

        <StepMessage
          iconDone
          message={
            <Trans id="client.request.estimation.message">
              The request has been successfully received by our team. We will update you on the next
              steps of the process.
            </Trans>
          }
        />

        <ClientArticlesList request={request} showPrice={showPrice} hideStepper={hideStepper} />

        {!isArchived(request) && <EstimateDisclaimer />}
      </Stack>
    </BrandRequestMainContent>
  );
};

export default Estimation;
